(function () {
  'use strict';

  function initHeroTypers() {
    document.querySelectorAll('[data-taupe-hero-typer]').forEach(function (typerEl) {
      if (typerEl.dataset.ready === 'true') return;
      typerEl.dataset.ready = 'true';

      var sectionId = typerEl.getAttribute('data-section-id');
      var dataEl = document.getElementById('TaupeHeroTyperData-' + sectionId);
      var words = [];

      try {
        words = JSON.parse(dataEl ? dataEl.textContent : '[]');
      } catch (e) {
        words = [];
      }

      if (!words.length) {
        words = ['Sew-In Units', 'Bundles & Wefts', 'Hair Care'];
      }

      var typeSpeed = parseInt(typerEl.getAttribute('data-type-speed'), 10) || 70;
      var deleteSpeed = parseInt(typerEl.getAttribute('data-delete-speed'), 10) || 40;
      var pauseMs = parseInt(typerEl.getAttribute('data-pause'), 10) || 2200;

      var wordIndex = 0;
      var charIndex = 0;
      var deleting = false;
      var timer;

      function tick() {
        var word = words[wordIndex];

        if (!deleting) {
          charIndex += 1;
          typerEl.textContent = word.slice(0, charIndex);

          if (charIndex === word.length) {
            deleting = true;
            timer = window.setTimeout(tick, pauseMs);
            return;
          }

          timer = window.setTimeout(tick, typeSpeed);
          return;
        }

        charIndex -= 1;
        typerEl.textContent = word.slice(0, charIndex);

        if (charIndex === 0) {
          deleting = false;
          wordIndex = (wordIndex + 1) % words.length;
          timer = window.setTimeout(tick, 320);
          return;
        }

        timer = window.setTimeout(tick, deleteSpeed);
      }

      typerEl.textContent = '';
      tick();

      typerEl.closest('.taupe-lane-hero')?.addEventListener('focusin', function () {
        window.clearTimeout(timer);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroTypers);
  } else {
    initHeroTypers();
  }

  document.addEventListener('shopify:section:load', initHeroTypers);
})();
